<template>
  <div v-show="isShow" class="window">
    <!-- 导航 -->
    <Navbar v-show="this.$route.path.indexOf('MakeNotes') === -1 && this.$route.path.indexOf('UpdateNotes')=== -1 && 
    this.$route.path.indexOf('/programmes/videoing')=== -1"></Navbar>
    <!-- posi用来定位所有路有距离导航的距离 -->
    <router-view></router-view>

    <br>
    <Footer v-show="this.$route.path === '/function' || this.$route.path === '/question' || this.$route.path === '/sweepstakes'
    || this.$route.path === 'homepage'"></Footer>
  </div>
</template>

<script>
// import { mounted } from 'vue2-ace-editor'
  import Footer from './components/Footer.vue'
  import Navbar from './pages/Navbar/Navbar.vue'
  import $ from "jquery"

  export default {
    name: "App",
    data() {
      return {
        isShow:true,
        Show: false,
      }
    },
    components: {
      Footer,
      Navbar,
    },
    watch: {
      $route(to, from) {
        if (to.path !== '/MyInfomation/manage')
        {
          this.isShow = false
          window.location.reload();
        }
      },
    },
    created() {
      

      // if (this.$store.state.me.id !== "") this.Show = true
      // else {
      //   const t = setInterval(() => {
      //     if (this.$store.state.me.id !== "") {
      //         console.log("我开始hh协议了")
      //         this.Show = true
      //         clearInterval(t); // 清除定时器
      //         console.log("我停止了")
      //     }
      //   }, 100);
      // }
    },

  }
</script>

<style lang="css" scoped>


.window {
  width: 100%;
  height: fit-content;
  /* background-color: rgb(233, 240, 243); */
  /* background-image: url('./assets/image/Light-img/Q1.jpg'); */
  background-size: cover;
  background-repeat:no-repeat;
  background-attachment: fixed;
}
</style>